import { AuthReqDeviceCoordsDto } from '~modules/auth/model';
import { Preloader } from '~shared/ui';

import { Scanner } from './Scanner';

type ScanCodePageProps = {
	onScan: (qr: string) => void;
	coords?: AuthReqDeviceCoordsDto | null;
	getPosition: () => void;
	isIncognito?: boolean;
};

export function ScanCode({ onScan, coords, getPosition, isIncognito }: ScanCodePageProps) {
	return (
		<div className="session-page__camera">
			<div className="camera">
				<h2>Отсканируйте QR-код на входе в участок</h2>
				{isIncognito && (
					<div className="camera__warning">
						Похоже, браузер работает в приватном режиме. В этом режиме устройство не опознается, и отметка
						может быть не засчитана - откройте сайт в обычном окне браузера.
					</div>
				)}
				<Scanner onDetect={onScan} />
			</div>
			<div className="coords">
				Ваши координаты: &nbsp;
				{coords ? (
					<>
						{coords.lat} {coords.lon}
					</>
				) : (
					<Preloader />
				)}
			</div>
			<button className="btn btn--primery" onClick={getPosition}>
				Определить координаты
			</button>
		</div>
	);
}
